(function(module) {

    "use strict";

    function constructor(filterBuilder) {

        // -------------------------------------------------------------------------------------------
        // The following functions create the filters from the content using the filter builders
        // -------------------------------------------------------------------------------------------

        var createFilter = asLocationHierarchyGroup(name, createExtractor() );

        // -------------------------------------------------------------------------------------------
        // General function for extracting properties and aggregating
        // -------------------------------------------------------------------------------------------

        /**
         *
         * @param  {Function} propertyExtractor a function that takes a location and returns the filter value for that location
         * @return {Function} the extractor function
         */
        function createExtractor(propertyExtractor) {
            return function(results) {
                var properties = results.map(function(property) {
                    return property != null ? property : null;
                });
                return properties.filter(function(property) {
                    return property != null;
                });
            };
        }

        // -------------------------------------------------------------------------------------------
        // Functions that take an extractor, they use the filter builder API to create the filters
        // -------------------------------------------------------------------------------------------

        /**
         * A function that takes filter group name and an extractor, it will return a function
         * that takes the filter builder and an array of locations, it will add a location hierarchy
         * group to the filter builder
         *
         * @param  {String} name the name of the filter group
         * @param  {Function} extractor the extractor function
         * @return {Function} a function to create the group
         */
        function asLocationHierarchyGroup(name, extractor) {
            return function(name, builder, facet) {
                // 1. create the filter group
                var groupBuilder = builder.addHierarchyFilters(name);

                // 2. walk the tree of locations, add the filters recursively
                (function build(filterBuilder, locations) {
                    locations.forEach(function(location) {
                        var locationFilterBuilder = filterBuilder.addFilter(location.description, [location.locationId]);
                        build(locationFilterBuilder, location.children || []);
                    });
                })(groupBuilder, extractor(facet));
            };
        }

        // -------------------------------------------------------------------------------------------
        // Result Filters
        // -------------------------------------------------------------------------------------------
        return function(results) {
            var builder = filterBuilder();

            createFilter("Tours", builder, results);
            return builder.build();
        };
    }

    module.factory("toursCruisesFilters", ["filterBuilder", constructor]);

})(angular.module("vhols"));
